import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddToCalendar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21 13.065V3.75H17.25V2.25H15.75V3.75H8.25V2.25H6.75V3.75H3V19.5C3 20.7375 4.0125 21.75 5.25 21.75H14.085C14.9025 22.23 15.855 22.5 16.875 22.5C19.98 22.5 22.5 19.98 22.5 16.875C22.5 15.405 21.93 14.0625 21 13.065ZM19.5 17.625H17.625V19.5H16.125V17.625H14.25V16.125H16.125V14.25H17.625V16.125H19.5V17.625ZM19.5 11.91C18.72 11.4825 17.8275 11.25 16.875 11.25C13.77 11.25 11.25 13.77 11.25 16.875C11.25 18.1425 11.67 19.3125 12.39 20.25H5.25C4.8375 20.25 4.5 19.9125 4.5 19.5V9.75H19.5V11.91ZM19.5 8.25H4.5V5.25H6.75V6.75H8.25V5.25H15.75V6.75H17.25V5.25H19.5V8.25Z",
		fill: "currentColor"
	})
});
export default SvgAddToCalendar;
